import { expandWithLifecycleSuffixes } from './lifecycle-suffixes.model';
import { MetricBaseUnit, SiPrefixAbbr } from './metric-units.model';

/**
 * CO2e units are also strange.. CO2e is not a unit, it's what the unit refers to.
 * It's normally described in kilograms
 */

export const co2eSuffix = 'CO2e';
export const co2eBaseSiUnits = ['g', 't'] as const satisfies MetricBaseUnit[];
export type CO2eBaseSiUnit = (typeof co2eBaseSiUnits)[number];

// we accept CO2e variants as a unit, as alias of kgCO2e.
export const unitLessCO2eUnits = ['co2e', 'CO2e'] as const;
type UnitLessCO2eUnit = (typeof unitLessCO2eUnits)[number];

export const co2eBaseUnits = co2eBaseSiUnits.map(
  (baseUnit) => `${baseUnit}${co2eSuffix}` as const,
);
export type CO2eBaseUnit =
  (typeof co2eBaseUnits)[number] | (typeof unitLessCO2eUnits)[number];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const acceptedCO2ePrefixes = ['k', 'M', 'G'] as const satisfies SiPrefixAbbr[];
type AcceptedCO2ePrefixes = (typeof acceptedCO2ePrefixes)[number];

// for mathjs definitions during unit creation
export const co2eUnitAliasMap = {
  gCO2e: expandWithLifecycleSuffixes('gCO2e'),
  tCO2e: expandWithLifecycleSuffixes('tCO2e'),
  CO2e: expandWithLifecycleSuffixes('CO2e'),
  co2e: expandWithLifecycleSuffixes('co2e'),
} satisfies Record<CO2eBaseUnit, string[]>;
export type CO2eUnitAliases = ObjectValues<typeof co2eUnitAliasMap>[number];

export const co2eUnitDefinitionMap = {
  gCO2e: { value: 1 },
  tCO2e: { definition: '1000000 gCO2e' },
  CO2e: { definition: '1000 gCO2e' },
  co2e: { definition: '1000 gCO2e' },
} satisfies Record<
  CO2eBaseUnit | UnitLessCO2eUnit,
  { value: number } | { definition: string }
>;

export type PrefixedCO2eAliases = `${AcceptedCO2ePrefixes}${CO2eUnitAliases}`;
export type PrefixedCO2eBaseUnit = `${AcceptedCO2ePrefixes}${CO2eBaseUnit}`;
export type CO2eUnit =
  | CO2eBaseUnit
  | PrefixedCO2eBaseUnit
  | UnitLessCO2eUnit
  | CO2eUnitAliases
  | PrefixedCO2eAliases;
